import { BaseResource } from "./base.resource";

export const ItemContainerMaterialAccessLevel = {
  None: 0,
  View: 1 << 0,
  Edit: 1 << 1,
  Delete: 1 << 2,
};

export class ItemContainerMaterial extends BaseResource {
  active: boolean;
  material: string;

  constructor(options?: any) {
    super(options);
    // Initialize properties...
  }

  get canView(): boolean {
    return (this.accessLevel & ItemContainerMaterialAccessLevel.View) > 0;
  }
  get canEdit(): boolean {
    return (this.accessLevel & ItemContainerMaterialAccessLevel.Edit) > 0;
  }
  get canDelete(): boolean {
    return (this.accessLevel & ItemContainerMaterialAccessLevel.Delete) > 0;
  }
}
